export default __webpack_public_path__ + "fefbf2447a764d312c725f467249223f.png";